import Financial from './financial'
import Utilization from './utilization'
import Projects from './projects'
import Sales from './sales'
import ProjectStatuses from './project-statuses'
import DefaultDashboard from './DefaultDashboard'
import Support from '../support/Dashboard'

export default {
    Financial,
    Utilization,
    Projects,
    Sales,
    ProjectStatuses,
    DefaultDashboard,
    Support
}
